import React, { useEffect } from 'react'
import SharedButton from '../../components/Shared/SharedButton'
import { useTranslation } from 'react-i18next'
import TpaTable from './TpaTable'
import { useNavigate } from 'react-router-dom'
import useFetchData from '../../hooks/useFetchData'

function TPA() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { data: listData, loading, executeFetch } = useFetchData()

  useEffect(() => {
    executeFetch("POST", "listTpa", { page: 1, per_page: 10 });
  }, [executeFetch]);

  const handlePageChange = (newPage, newRowsPerPage) => {
    executeFetch("POST", "listTpa", { page: newPage, per_page: newRowsPerPage });
  };

  const handleRefresh = () => {
    executeFetch("POST", "listTpa", { page: 1, per_page: 10 });
  };

  return (
    <div className=''>
      <div className='flex justify-end mb-2'>
        <div className='flex gap-4'>
          <SharedButton
            label={`${t('create')} ${t('tpa')}`}
            icon='pi pi-plus'
            className='bg-primary primary-btn'
            onClick={() => navigate('/manager/tpa/create')}
          />
        </div>
      </div>
      <TpaTable
        listData={listData}
        isLoading={loading}
        onPageChange={handlePageChange}
        onRefresh={handleRefresh}
      />
    </div>
  )
}

export default TPA
